import { RTABAK_URLS } from "../utils/urls";
import request from "./request";

type heroParams = { mobileHero?: boolean };

const heroServices = {
  getHero: async (params?: heroParams): Promise<any> =>
    request({
      method: "get",
      baseURL: RTABAK_URLS.API.Hero,
      params,
    }),
};

export { heroServices };
